document.addEventListener('click', function (event) {

    // Check if Submit button was clicked
    if (event.target.id !== 'kr-button') {
        return;
    }

    const nicknameInput = document.querySelector('#kr-nckName');
    const nicknameMinError = document.querySelector('#kr-nickname-error');
    const nicknameMaxError = document.querySelector('#kr-nicknamemax-error');

    if (!nicknameInput) {
        return;
    }

    // Wait a little for the form validation to add the "show" class
    setTimeout(function () {

        const hasNicknameError =
            nicknameMinError?.classList.contains('show') ||
            nicknameMaxError?.classList.contains('show');

        if (hasNicknameError) {
            nicknameInput.classList.add('error-focus');
        }

    }, 100);

});
document.addEventListener('input', function (event) {

    if (event.target.id !== 'kr-nckName') {
        return;
    }

    event.target.classList.remove('error-focus');

});